import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentGroup } from '../../utils/experiments';
import { isAvailableInRegions } from '../../selectors/regions';
import { NB_HELP_IN_SEARCH } from '../../constants/experiments';
import { MOSCOW_ID, MOSCOW_AREA_ID, MOSCOW_AND_MOSCOW_AREA_ID } from '../../constants/geo';

export function helpInSearchSelector(state: IApplicationState) {
  const { abUseExperiments, newbuildingConsultant } = state;
  const availableRegions = [MOSCOW_ID, MOSCOW_AREA_ID, MOSCOW_AND_MOSCOW_AREA_ID];

  return !!newbuildingConsultant.accountName &&
    isAbUseExperimentGroup(abUseExperiments, NB_HELP_IN_SEARCH, 'version1') &&
    isAvailableInRegions(availableRegions)(state);
}
